module.exports = __webpack_public_path__ + "static/img/user-bg.3de59b8a.png";